import Psychotherapist from './Psychotherapist.js';

export default Psychotherapist;
